import React, { ReactElement } from 'react';

import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const GeminiCom = React.lazy(() => import('../components/Gemini'));

function Gemini(): ReactElement {
  return (
    <SuspenseLoadPage>
      <GeminiCom />
    </SuspenseLoadPage>
  );
}

export default Gemini;
